const mutations = {
  change(state, filterDate) {
    state.filterDate = filterDate
  },
  changeTab(state, currentTab) {
    state.currentTab = currentTab
  }
}

export default mutations